import React, { useRef, useState, useEffect, useCallback } from "react";
import "./VolumeBar.css"

function clamp(v, a = 0, b = 1) {
  return Math.max(a, Math.min(b, v));
}

export default function VolumeBar({ value, onChange }) {
  const [isDragging, setIsDragging] = useState(false);
  const [previewValue, setPreviewValue] = useState(null);
  const barRef = useRef(null);

  const getPercentFromEvent = (e) => {
    const rect = barRef.current.getBoundingClientRect();
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    const x = rect.bottom - clientY;
    return clamp(x / rect.height, 0, 1);
  };

  const handleStart = (e) => {
    e.preventDefault();
    setIsDragging(true);
    const percent = getPercentFromEvent(e);
    setPreviewValue(percent);
    onChange?.(percent);
  };

  const handleMove = useCallback(
    (e) => {
      if (!isDragging) return;
      const percent = getPercentFromEvent(e);
      setPreviewValue(percent);
      onChange?.(percent);
    },
    [isDragging, onChange]
  );

  const handleEnd = useCallback(() => {
    if (!isDragging) return;
    setIsDragging(false);
    setPreviewValue(null);
  }, [isDragging]);

  useEffect(() => {
    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleEnd);
    document.addEventListener("touchmove", handleMove);
    document.addEventListener("touchend", handleEnd);

    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("touchend", handleEnd);
    };
  }, [handleMove, handleEnd]);

  const effectiveValue = isDragging ? previewValue : value;

  return (
    <div
      ref={barRef}
      className="volume-bar"
      onMouseDown={handleStart}
      onTouchStart={handleStart}
    >
      <div
        className="volume-filled"
        style={{ height: `${effectiveValue * 100}%` }}
      />
    </div>
  );
}
